import { render, staticRenderFns } from "./horizontalTemplate.vue?vue&type=template&id=66da5db5&"
import script from "./horizontalTemplate.vue?vue&type=script&lang=ts&"
export * from "./horizontalTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports